import { Layout } from 'antd'
import { FC, useEffect } from 'react'
import { useAppDispatch, useAppSelector } from '../../app/hook'
import { IMGs } from '../../assets/img'

import { LeaderBoardLayout } from '../../components'
import { StatisticBoxes } from '../EndSeason/components/ChallengerBox/StatisticBoxes'
import { fetchLeaderBoard } from '../LeaderBoard/leaderBoardSlice'
import { Header } from './components'
import { Top3Users } from './components/Top3Users/Top3Users'
import { TopChallengers } from './components/TopChallengers/TopChallengers'

import { useTranslation } from 'react-i18next'

export const EndSeason: FC<unknown> = () => {
    const { t } = useTranslation()
    const { rewards } = useAppSelector((state) => state.leaderBoard)
    const { rank, season, statistic } = useAppSelector(
        (state) => state.leaderBoard
    )
    const dispatch = useAppDispatch()

    useEffect(() => {
        dispatch(
            fetchLeaderBoard({
                limit: 100,
                page: 1,
                boardName: 'mock-previous-season',
                stats: true,
            })
        )
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <LeaderBoardLayout isSeasonHeaderHidden>
            <Layout
                style={{
                    background: 'transparent',
                    backgroundImage: `url(${IMGs.END_SEASON})`,
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: '100% 100%',
                }}
            >
                <Header
                    title={t('txt_trading_simulator')}
                    subTitle={
                        season?.title
                            ? `${season.title?.toUpperCase()} ${t(
                                  'txt_summary'
                              ).toUpperCase()}`
                            : ''
                    }
                />
                {rank && rank.length ? <Top3Users rank={rank} /> : null}
                {/* {rewards && rewards.length && <TotalPrize rewards={rewards} />} */}
                {statistic && <StatisticBoxes statistic={statistic} />}
            </Layout>
            {rank && rank.length ? (
                <TopChallengers rank={rank} notTop3 darkBackground />
            ) : null}
        </LeaderBoardLayout>
    )
}
